import { Report } from '../types';

export const getHasOverrideColumn = (report: Report) => {
  return (
    report?.review &&
    Boolean(Object.values(report?.review)?.some?.((review) => Boolean(review?.overrideResponse)))
  );
};
